import { Controller } from "@hotwired/stimulus"

// Bottom Sheet Controller
// Mobile team switcher with slide-up animation.
// Team switching uses Turbo.visit instead of manual fetch.
export default class extends Controller {
  static targets = ["sheet", "backdrop", "list"]

  connect() {
    this.isOpen = false
    this._handleEscape = this._handleEscape.bind(this)
  }

  disconnect() {
    this._unlock()
    document.removeEventListener("keydown", this._handleEscape)
  }

  open(event) {
    event.preventDefault()
    if (this.isOpen) return
    this.isOpen = true
    this.sheetTarget.classList.remove("hidden")
    this.sheetTarget.getBoundingClientRect()
    this.sheetTarget.classList.remove("translate-y-full")
    this.sheetTarget.classList.add("translate-y-0")
    this.backdropTarget.classList.remove("hidden", "opacity-0")
    this.backdropTarget.classList.add("opacity-100")
    this._lock()
    document.addEventListener("keydown", this._handleEscape)
  }

  close() {
    if (!this.isOpen) return
    this.isOpen = false
    this.sheetTarget.classList.remove("translate-y-0")
    this.sheetTarget.classList.add("translate-y-full")
    this.backdropTarget.classList.remove("opacity-100")
    this.backdropTarget.classList.add("opacity-0")
    setTimeout(() => {
      if (this.isOpen) return
      this.backdropTarget.classList.add("hidden")
      this.sheetTarget.classList.add("hidden")
    }, 200)
    this._unlock()
    document.removeEventListener("keydown", this._handleEscape)
  }

  // Navigation removed — team switching now uses data-turbo-method="post" links.
  // The close() method is triggered via data-action="click->bottom-sheet#close" on the links.

  _handleEscape(event) { if (event.key === "Escape") this.close() }

  _lock() {
    this._scrollY = window.scrollY
    document.body.style.position = "fixed"
    document.body.style.top = `-${this._scrollY}px`
    document.body.style.width = "100%"
  }

  _unlock() {
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.width = ""
    if (this._scrollY !== undefined) window.scrollTo(0, this._scrollY)
  }
}
